import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconDocumentXlsProps } from './IconDocumentXls.types'
import * as Styled from './styles/IconDocumentXls.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentXls: FC<IconDocumentXlsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentXlsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconDocumentXlsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M5.637 6.543H9.5V2.797' vectorEffect='non-scaling-stroke' />
          <path
            d='M10.355 2.543a2.15 2.15 0 0 0-1.39.512l-2.703 2.32a2.124 2.124 0 0 0-.742 1.617v12.465c0 1.098.902 2 1.742 2h9.218c1.36 0 2-.902 2-2V2.543Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M11.434 11.465v3.039h1.52M7.86 11.465l1.898 3.039m-1.961 0 1.898-3.04m4.755 2.864s.363.297 1.027.258c.335-.02.8-.234.718-.84-.078-.61-1.25-.934-1.25-.934s-.492-.136-.5-.613a.755.755 0 0 1 .7-.8h.05c.332-.032.668.062.93.273'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconDocumentXls
